module.exports = __webpack_public_path__ + "media/images/new/camp_protect_educate@2x-6be567c509be9abd2cce2864f165b7d0.jpg";